import moment from 'moment' // 导入文件
import {
  getTreeInfo
} from '@/utils/common.js'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

export function searchList(id, list, name, retName, defaultText = '——') {
  if (list.length === 0) return defaultText
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i][name] == id) {
      return list[i][retName]
    }
  }
  return defaultText
}

export function searchOptions(id, list, defaultText) {
  return searchList(id, list, 'value', 'lable', defaultText)
}

export function searchCode(id, list) {
  return searchList(id, list, 'code', 'name')
}

export function calculateAccuracy(correctCount, totalCount) {
  // 确保传入的参数为有效的数字
  if (typeof correctCount !== 'number' || typeof totalCount !== 'number' || totalCount === 0) {
    return '0%'
  }

  // 计算正确率，保留两位小数
  const accuracy = (correctCount / totalCount) * 100
  if (Number.isInteger(accuracy)) {
    return accuracy.toFixed(0) + '%'
  } else {
    return accuracy.toFixed(2) + '%'
  }
}

// 传入字符串转数字后再根据是否有小数位保留两位小数或保留整数
export function formatNumber(num, unit = '') {
  const number = Number(num)
  if (Number.isNaN(number)) {
    return num
  }
  if (number % 1 === 0) {
    return number.toFixed(0) + unit
  } else {
    return number.toFixed(2) + unit
  }
}

/**
 *
 * @param {*} id id等数据
 * @param {*} treeList 数据源
 * @param {*} name 与id比对的key
 * @param {*} retName 返回的字段
 * @param {*} childrenName 属性结构的子节点名称
 */
export function searchTreeList(id, treeList, name = 'id', retName = 'title', childrenName = 'children') {
  // list
  const unfoldTree = [] //  展开属性结构的数据
  // 每次展开（当局部刷新之后关心这个）
  const recursionChild = list => {
    if (list && list.length) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        unfoldTree.push(item)
        if (item[childrenName] && item[childrenName].length) {
          recursionChild(item[childrenName])
        }
      }
    }
  }
  recursionChild(treeList)
  return searchList(id, unfoldTree, name, retName)
}

export function defaultText(data, text, appendText = '') {
  // 数据是 null  undefined NaN ''
  if (data === null || data === undefined || data === '' || (typeof data === 'number' && isNaN(data))) return text || '——'
  return `${data}${appendText}`
}

export function notNull(data, name) {
  if (data) {
    if (name && data[name]) {
      return data[name]
    } else if (!name) {
      return data
    } else {
      return '——'
    }
  } else {
    return '——'
  }
}

export function hours2Day(hours) {
  if (hours == null) {
    return 0
  }
  return Math.floor(hours / 24)
}

export function fen2yuan(value) {
  if (value == null) {
    return 0
  }
  return Math.floor(value / 100)
}

export function DataNotNull(data) {
  if (!data) return '——'
  return data
}

export function FormatTime(time) {
  if (time === '——') return time
  const FormatTime =
    time.substring(0, 4) +
    '-' +
    time.substring(4, 6) +
    '-' +
    time.substring(6, 8) +
    ' ' +
    time.substring(8, 10) +
    ':' +
    time.substring(10, 12) +
    ':' +
    time.substring(12, 14)
  return FormatTime
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/* 数字 格式化*/
export function nFormatter(num, digits) {
  const si = [{
    value: 1e18,
    symbol: 'E'
  },
  {
    value: 1e15,
    symbol: 'P'
  },
  {
    value: 1e12,
    symbol: 'T'
  },
  {
    value: 1e9,
    symbol: 'G'
  },
  {
    value: 1e6,
    symbol: 'M'
  },
  {
    value: 1e3,
    symbol: 'k'
  }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num.toString()
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function IndexNumber(index, pageindex, limit) {
  return index + 1 + (pageindex - 1) * limit
}

export function moneyFormat(data) {
  if (data) {
    return data / 100
  } else {
    return 0
  }
}
// 首页同比数据展示
export function positiveNumber(data) {
  if (data === '--') {
    return data
  } else {
    const retData = data > 0 ? data : -data
    return retData
  }
}

export function plusOrminus(data) {
  if (data > 0) {
    return '+' + data
  } else {
    return data
  }
}

export function filterPrice(price) {
  // 价格是分
  if (price) {
    return (parseInt(price) / 100).toFixed(2)
  } else {
    return '0.00'
  }
}

/**
 * 除n
 * @param {*} val
 * @param {*} n
 * @returns
 */
export function divideNumber(val, n = 100) {
  if (!val) return 0
  let num = val / n
  num = num.toString()
  const index = num.indexOf('.')
  if (index !== -1) {
    num = num.substring(0, 2 + index + 1)
  } else {
    num = num.substring(0)
  }
  return Math.round(num * 100) / 100
}

/**
 * 乘n
 * @param {*} val
 * @param {*} n
 * @returns
 */
export function rideNumber(val, n = 100, appendText = '%') {
  if (!val) return 0
  val = val.toString()
  if (appendText) {
    return (val * n).toFixed(2) + appendText
  } else {
    return (val * n).toFixed(2)
  }
}

/**
 * 根据时间差值返回具体时长
 * @param {*} diffTime 1000 时间差值
 * @param {*} type seconds默认秒
 * @returns 1天 1:1:1
 */
export function diffTimeFormat(diffTime, type = 'seconds') {
  let diffTimeFormat = ''
  if (diffTime) {
    const diffTimeInfo = moment.duration(diffTime, type)
    diffTimeFormat = `${diffTimeInfo.days() > 0 ? diffTimeInfo.days() + '天' : ''}${diffTimeInfo.hours()}:${diffTimeInfo.minutes()}:${diffTimeInfo.seconds()}`
  }
  return diffTimeFormat
}

/**
 * 精度处理
 * @param {*} num
 * @returns
 */
export function numberPrecision(num) {
  return Math.round(num * 100) / 100
}

/**
 * 根据id返回当前子节点到父根节点的数据
 * @param {*} id
 * @param {*} tree
 * @param {*} key title
 * @param {*} self true
 */
export function tree2Text(id, tree, key = 'title', self = true) {
  return getTreeInfo(id, tree, self, key).join('/') || '——'
}

/**
 * 对时间格式化
 * @param {*} time
 * @param {*} format
 */
export function timeFormat(time, format = 'YYYY-MM-DD HH:mm:ss') {
  // time为空直接返回
  if (defaultText(time) === '——') return defaultText(time)
  return moment(new Date(`${time}`)).format(format)
}

/**
 * 时间戳格式化
 * @param {*} time
 * @param {*} format
 * @returns
 */
export function timestampFormat(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  // time为空直接返回
  if (defaultText(timestamp) === '——') return defaultText()
  return moment(timestamp).format(format)
}

/**
 * 时长格式化
 */
export function durationformat(millisecond, format) {
  const padZero = (value) => {
    // 在个位数前面补零
    return value < 10 ? `0${value}` : value
  }

  // 使用 Moment.js 格式化时间
  const duration = moment.duration(millisecond, 'millisecond')

  // 获取小时、分钟和秒
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  const seconds = duration.seconds()

  // 根据传入的格式进行处理
  switch (format) {
    case 'HH:mm:ss':
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    case 'HH时mm分ss秒':
      return `${padZero(hours)}时${padZero(minutes)}分${padZero(seconds)}秒`
    default:
      // 默认格式：250时30分9秒、10分10秒、9秒
      const formattedTime = []
      if (hours > 0) formattedTime.push(`${hours}时`)
      if (minutes > 0) formattedTime.push(`${minutes}分`)
      if (seconds > 0 || (hours === 0 && minutes === 0)) formattedTime.push(`${seconds}秒`)
      return formattedTime.join('')
  }
}

/** 加密身份证号码 */
export function encryptionIDcard(card) {
  return card ? card.replace(/(\d{6})(\d{8})(\d{4})/, '$1********$3') : '——'
}
